import { activityTimeBounds, type ActivityQuery, type ActivityTime } from '../../app/activity-query'
import type { ActivityItem } from './merge'

export type { ActivityTime }

export function activityStreamParams(query: ActivityQuery): URLSearchParams {
  const params = new URLSearchParams()
  if (query.view) params.set('view', query.view)
  if (query.projectId) params.set('project_id', query.projectId)
  if (query.scope) params.set('scope', query.scope)
  if (query.type) params.set('type', query.type)
  if (query.status) params.set('status', query.status)
  if (query.actor) params.set('actor', query.actor)
  if (query.q) params.set('q', query.q)
  const bounds = activityTimeBounds(query.time)
  if (bounds.occurredAfter) params.set('occurred_after', bounds.occurredAfter)
  if (bounds.occurredBefore) params.set('occurred_before', bounds.occurredBefore)
  return params
}

export function matchesActivityQuery(item: ActivityItem, query: ActivityQuery, now = new Date()): boolean {
  if (query.projectId && item.project_id !== query.projectId) return false
  if (query.scope === 'account' && item.scope_type !== 'account') return false
  if (query.type && item.object_type !== query.type && !item.event_type.startsWith(`${query.type}.`)) return false
  if (query.status && !query.status.split(',').includes(item.status)) return false
  if (query.actor && item.actor_id !== query.actor && item.actor_display !== query.actor) return false
  if (query.q) {
    const needle = query.q.toLocaleLowerCase()
    const blob = `${item.summary} ${item.object_id} ${item.actor_display}`.toLocaleLowerCase()
    if (!blob.includes(needle)) return false
  }
  const bounds = activityTimeBounds(query.time, now)
  const occurred = Date.parse(item.occurred_at)
  if (bounds.occurredAfter && occurred < Date.parse(bounds.occurredAfter)) return false
  if (bounds.occurredBefore && occurred >= Date.parse(bounds.occurredBefore)) return false
  if (query.view === 'action' && !item.requires_action) return false
  if (query.view === 'important' && !isImportantActivity(item)) return false
  return true
}

function isImportantActivity(item: ActivityItem): boolean {
  if (item.requires_action) return true
  if (['awaiting_decision', 'awaiting_dependency', 'platform_held', 'disconnected', 'recovering', 'production_verified', 'failed', 'rolled_back', 'unknown'].includes(item.status)) {
    return true
  }
  if (item.status === 'running') return ['task', 'release', 'resource', 'site'].includes(item.object_type)
  if (item.status === 'completed') {
    return !item.event_type.startsWith('conversation.created') && ['task', 'release', 'resource', 'site', 'project'].includes(item.object_type)
  }
  return false
}
